import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

import type { IOrderFormJson } from '../types/order-form-json.type'

export type TOrderFormCalculationService = {
  payload: {
    jsonOrderForm: IOrderFormJson
    productIdToCalculate?: string[]
    calculationCommissionChanged?: boolean
  }
}

export const orderFormCalculationService = async ({
  payload,
}: TOrderFormCalculationService): Promise<ResponseAPI> => {
  const response = await api.post('calcularpedido', payload.jsonOrderForm, {
    headers: {
      item: payload.productIdToCalculate && payload.productIdToCalculate,
      TipoPorcValor: payload.calculationCommissionChanged === true && 'C',
      AtualizaDadosCliente: payload.jsonOrderForm.parametros
        .atualizaDadosCliente
        ? 'true'
        : 'false',
    },
  })

  return response.data
}
